import { RootState } from 'handlers';

export const getKyc = ({ kyc }: RootState) => kyc;
